module.exports = __webpack_public_path__ + "static/installationspartner-env2-min-3c72315ea08cf36f0f612e3908f688b1.jpg";